var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("signWaitHeading")))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('signWaitText'))}}),_c('v-progress-linear',{attrs:{"value":_vm.progress,"height":"25","rounded":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('strong',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }